var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    role: "img",
    "aria-label": "Stacked servers icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 46,
    height: 13,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 26,
    width: 46,
    height: 13,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 42,
    width: 46,
    height: 13,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 16.5,
    r: 2,
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 32.5,
    r: 2,
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 48.5,
    r: 2,
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 16.5 H46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 32.5 H46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 48.5 H46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStack);
export default __webpack_public_path__ + "static/media/Icon.Stack.e2e1de2937b7659e120d9079db9a405a.svg";
export { ForwardRef as ReactComponent };